import { Component, Input } from '@angular/core';
import { Globals } from "../../../globals";

/**
 * Generated class for the IngredientsMeasurementComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'most-sales-elements',
  templateUrl: 'most-sales-elements.html'
})
export class MostSalesElementsComponent {
  @Input() mostSalesElements;
  @Input() chartSalesElementsData;
  @Input() chartSalesElementsLabels;
  @Input() chartSalesElementsTable;
  @Input() chartSalesElementsOptions;
  @Input() chartSalesElementsType;
  @Input() chartElementsColors;


  ver_todo: boolean = false;
  constructor(public globals: Globals, ) {
  }

  ver_mas(){
    this.ver_todo = true;
  }
  ver_menos(){
    this.ver_todo = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/analytics/most-sales-elements/most-sales-elements.ts